<template>
  <DragPanel
    title="锚点"
    :closePanel="closePanel"
    :tooltipVisible="false">
    <div class="anchor-filter-box">
      <div class="label-box">锚点类型：</div>
      <el-select
        class="primary-select"
        size="small"
        v-model="anchorPointTypeId"
        clearable
        :popper-append-to-body="false"
        @focus="initAnchorTypeList()"
        @change="updateAnchorList">
        <el-option
          v-for="(item, index) in anchorTypeList"
          :key="index"
          :label="item.typeName"
          :value="item.typeId">
          <div
            class="text-overflow"
            :title="item.typeName">
            {{ item.typeName }}
          </div>
        </el-option>
      </el-select>
    </div>
    <AnchorList
      :anchorList="filterAnchorList"
      @openAnchorDetailsPanel="openAnchorDetailsPanel" />
    <AnchorDetailsPanel
      v-if="isAnchorDetailsPanelVisible"
      :sceneInfo="sceneInfo"
      :anchorDetails="anchorDetails"
      @closeAnchorDetailsPanel="closeAnchorDetailsPanel" />
  </DragPanel>
</template>

<script>
import DragPanel from '@/components/CustomDragPanel.vue'
import AnchorList from './AnchorList.vue'
import AnchorDetailsPanel from './AnchorDetailsPanel.vue'

import {
  getSceneAnchorListService,
  getAnchorTypeListService
} from '@/service/share/sceneShareInterface.js'

// prettier-ignore
const animAnchorPicPath = "https://demo.bjblackhole.com/css/img/anc_anim - 副本.png";

// prettier-ignore
const mergePicPath = 'https://demo.bjblackhole.com/demopage/examplesImgs/bubbler.png';

export default {
  data() {
    return {
      anchorPointTypeId: '',
      anchorTypeList: [],
      originAnchorList: [],
      filterAnchorList: [],

      isAnchorDetailsPanelVisible: false,
      anchorDetails: {}
    }
  },
  props: {
    sceneInfo: Object
  },
  components: {
    DragPanel,
    AnchorList,
    AnchorDetailsPanel
  },
  mounted() {
    this.initData()
  },
  beforeDestroy() {},
  methods: {
    initData() {
      this.initAnchorList().then(async () => {
        this.anchorTypeList = await this.queryAnchorTypeList()
        this.addAnchlorList(this.filterAnchorList)
      })
    },
    initAnchorList() {
      return new Promise(resolve => {
        this.queryAnchorList().then(anchorList => {
          this.originAnchorList = anchorList
          this.filterAnchorList = anchorList
          resolve()
        })
      })
    },
    async initAnchorTypeList() {
      this.anchorTypeList = await this.queryAnchorTypeList()
    },
    updateAnchorList(value) {
      const BlackHole3D = window.BlackHole3D
      let groupIds = this.originAnchorList.map(item => item.groupId)
      groupIds.forEach(groupId => {
        BlackHole3D.Anchor.delGroupAnc(groupId)
      })

      let filterAnchorList = []
      this.originAnchorList.forEach(item => {
        let anchorPointList = item.anchorPointList.filter(anchor => {
          if (value) {
            return anchor.anchorPointTypeId === value
          } else {
            return true
          }
        })
        let obj = { ...item }
        obj.anchorPointList = anchorPointList
        filterAnchorList.push(obj)
      })
      this.filterAnchorList = filterAnchorList
      this.addAnchlorList(filterAnchorList)
    },
    closePanel() {
      if (!this.sceneInfo.enableAnchorPointShow) {
        const BlackHole3D = window.BlackHole3D
        BlackHole3D.Anchor.delAllAnc()
      }

      this.$emit('closeAnchorPanel')
    },
    openAnchorDetailsPanel(anchorDetails) {
      this.anchorDetails = anchorDetails
      this.isAnchorDetailsPanelVisible = true
    },
    closeAnchorDetailsPanel() {
      this.anchorDetails = {}
      this.isAnchorDetailsPanelVisible = false
    },
    addAnchlorList(anchorGroupList) {
      const BlackHole3D = window.BlackHole3D

      let normalAnchorList = []
      let animAnchorList = []
      anchorGroupList.forEach(item => {
        let anchorList = item.anchorPointList
        anchorList.forEach(anchor => {
          let visibleDistanceUnit = anchor.visibleDistanceUnit
          let scalingThresholdUnit = anchor.scalingThresholdUnit
          // prettier-ignore
          let selfAutoScaleDist = scalingThresholdUnit === "Kilometer" ? anchor.scalingThreshold * 1000 : anchor.scalingThreshold;
          // prettier-ignore
          let selfVisDist = visibleDistanceUnit === "Kilometer" ? anchor.visibleDistance * 1000 : anchor.visibleDistance;

          let anchorInfo = {
            groupName: item.groupId,
            ancName: anchor.sceneAnchorPointId,
            pos: JSON.parse(anchor.position),
            textInfo: anchor.name,
            picWidth: 32,
            picHeight: 32,
            selfAutoScaleDist: selfAutoScaleDist,
            selfVisDist: selfVisDist,
            texBias: [0, 1],
            texFocus: [16, 0],
            textClr: new BlackHole3D.REColor(255, 255, 255, 255),
            useLod: item.aggregationStatus ? true : false
          }

          if (anchor.displayForm === 0) {
            let timestamp = new Date().getTime()
            let picPath = `${window.imageBaseUrl}/${anchor.iconUrl}?timestamp=${timestamp}`
            anchorInfo.ancSize = 32
            anchorInfo.picPath = picPath
            const isAnchorExist = BlackHole3D.Anchor.getAnc(anchorInfo.ancName)
            if (!isAnchorExist) {
              normalAnchorList.push(anchorInfo)
            }
          } else {
            anchorInfo.picPath = animAnchorPicPath
            anchorInfo.picNum = 6
            anchorInfo.playFrame = 2
            const isAnchorExist = BlackHole3D.Anchor.getAnc(anchorInfo.ancName)
            if (!isAnchorExist) {
              animAnchorList.push(anchorInfo)
            }
          }
        })
      })

      if (normalAnchorList.length) {
        BlackHole3D.Anchor.addAnc(normalAnchorList)
      }

      if (animAnchorList.length) {
        BlackHole3D.Anchor.addAnimAnc(animAnchorList)
      }
      
      if (!normalAnchorList.length && !animAnchorList.length) return

      let mergeGroup = anchorGroupList.filter(el => el.aggregationStatus)
      let mergeAnchorGroupList = []

      const mergestyle = new BlackHole3D.REAncInfo()
      mergestyle.picPath = mergePicPath
      mergestyle.picWidth = 32
      mergestyle.picHeight = 32
      mergestyle.textBias = [1, 0]
      mergestyle.fontName = 'RealBIMFont001'
      mergestyle.textClr = new BlackHole3D.REColor(255, 255, 255, 255)

      mergeGroup.forEach(item => {
        let ancLODInfo = new BlackHole3D.REAncLODInfo()
        ancLODInfo.groupName = item.groupId
        ancLODInfo.lodLevel = 10
        ancLODInfo.useCustomBV = false
        ancLODInfo.customBV = []
        ancLODInfo.lodMergePxl = 300.0
        ancLODInfo.lodMergeCap = 2
        ancLODInfo.mergeStyle = mergestyle
        mergeAnchorGroupList.push(ancLODInfo)
      })

      mergeAnchorGroupList.forEach(item => {
        BlackHole3D.Anchor.setAncLODInfo(item)
      })
    },
    queryAnchorList() {
      return new Promise(resolve => {
        let sceneId = this.$route.params.resourceId
        let headers = this.getHeaders()
        getSceneAnchorListService(sceneId, headers).then(response => {
          if (response.isSuccess) {
            let anchorList = response.data
            anchorList.forEach(item => {
              item.originGroupName = item.groupName
              let anchorPointList = item.anchorPointList
              anchorPointList.forEach(anchorInfo => {
                anchorInfo.groupName = item.groupName
              })
            })
            resolve(anchorList)
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    async queryAnchorTypeList() {
      let projectZoneId = this.sceneInfo.projId
      let headers = this.getHeaders()
      let response = await getAnchorTypeListService({ projectZoneId }, headers)
      if (response.isSuccess) {
        let data = response.data
        let anchorTypeList = data.map(item => {
          item.typeName = item.name
          item.typeId = item.anchorPointTypeId
          return item
        })
        return anchorTypeList
      } else {
        this.$message.error(response.errMsg)
      }
    },
    getHeaders() {
      let token = this.$route.query.token
      let headers = {
        Authorization: token
      }
      return headers
    }
  }
}
</script>

<style lang="less" scoped>
.common-drag-panel {
  top: 214px;
  right: 20px;
  width: 360px;
  height: calc(100% - 225px);

  :deep(.content) {
    display: flex;
    flex-direction: column;
    height: calc(100% - 40px);
    padding: 8px 16px 16px 16px;

    .anchor-filter-box {
      display: flex;
      align-items: center;
      margin-top: 8px;
      font-size: 14px;

      .label-box {
        flex-shrink: 0;
      }

      .primary-select {
        flex-grow: 1;

        .el-select-dropdown {
          width: 100%;
        }
      }
    }
  }
}
</style>
